export default class PermissionUtils {
    static permissionCheckingProp(permission) {
        return `isCheckingPermission${permission}`;
    }

    static isAccessibleProp(permission) {
        return `isPermitted${permission}`;
    }
}
